const PAYMENT_CATEGORIES = {
    PAYMENT: 'payment',
    BULK_PAYMENT: 'payment-approve-all',
    CROSSBORDER_PAYMENT: 'cross-border-payment',
    DOWNPAYMENT: 'downpayment',
    EFAKTURA: 'efaktura',
    BATCH_EFAKTURA: 'batch-efaktura',
};
const AVATALEGIRO_CATEGORIES = {
    CREATE_AVTALEGIRO: 'create-avtalegiro',
    UPDATE_AVTALEGIRO: 'update-avtalegiro',
    DELETE_AVTALEGIRO: 'delete-avtalgiro',
};
const ANALYTICS_CATEGORIES = {
    ...PAYMENT_CATEGORIES,
    ...AVATALEGIRO_CATEGORIES,
    SHARE_EFAKTURA: 'share-eFaktura',
    TRANSFER: 'transfer',
    UPDATE_PAYMENT_LIMITS: 'update-payment-limits',
    UPDATE_RECEIVER: 'update-receiver',
    UPDATE_PAYMENT_ITEM: 'update-payment-item',
    CLOSE_ACCOUNT: 'close-account',
    UPDATE_CONTACT_INFO: 'update-contact-info',
};
export default ANALYTICS_CATEGORIES;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2F0ZWdvcmllcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9hbmFseXRpY3MvY2F0ZWdvcmllcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLGtCQUFrQixHQUFHO0lBQ3ZCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLFlBQVksRUFBRSxxQkFBcUI7SUFDbkMsbUJBQW1CLEVBQUUsc0JBQXNCO0lBQzNDLFdBQVcsRUFBRSxhQUFhO0lBQzFCLFFBQVEsRUFBRSxVQUFVO0lBQ3BCLGNBQWMsRUFBRSxnQkFBZ0I7Q0FDbkMsQ0FBQztBQUVGLE1BQU0sc0JBQXNCLEdBQUc7SUFDM0IsaUJBQWlCLEVBQUUsbUJBQW1CO0lBQ3RDLGlCQUFpQixFQUFFLG1CQUFtQjtJQUN0QyxpQkFBaUIsRUFBRSxrQkFBa0I7Q0FDeEMsQ0FBQztBQUVGLE1BQU0sb0JBQW9CLEdBQUc7SUFDekIsR0FBRyxrQkFBa0I7SUFDckIsR0FBRyxzQkFBc0I7SUFDekIsY0FBYyxFQUFFLGdCQUFnQjtJQUNoQyxRQUFRLEVBQUUsVUFBVTtJQUNwQixxQkFBcUIsRUFBRSx1QkFBdUI7SUFDOUMsZUFBZSxFQUFFLGlCQUFpQjtJQUNsQyxtQkFBbUIsRUFBRSxxQkFBcUI7SUFDMUMsYUFBYSxFQUFFLGVBQWU7SUFDOUIsbUJBQW1CLEVBQUUscUJBQXFCO0NBQzdDLENBQUM7QUFFRixlQUFlLG9CQUFvQixDQUFDIn0=